<template>
  <EntityForm :entity="profileData" :inputFields="ORGUNIT_FIELDS" @update:entity="$emit('update:profileData', $event)" />
</template>

<script>
import EntityForm from "@/components/EntityForm.vue";
import Auth0Mixin from "@/views/Auth0Mixin";
import lookupServices from "@/services/servicesLookupService.js";
import ValidationRules from "../validationRules";

const ZIP_CODE = "Zip Code";
const POSTAL_CODE = "Postal Code";
const requiredRule = [v => !!v || "Required"];
const ZIPCODE_INDEX = 7;
const STATE_INDEX = 5;
const TAX_ID_TYPE_INDEX = 9;
const COUNTRY_INDEX = 4;
const TAX_NUMBER_INDEX = 10;
export default {
  name: "PartialProfile",
  components: {
    EntityForm,
  },
  mixins: [Auth0Mixin],
  props: {
    profileData: Object,
  },
  emits: ["update:profileData"],
  data() {
    return {
      ORGUNIT_FIELDS: [
        { label: "Name", attribute: "name", rules: requiredRule, type: "text" },
        {
          label: "Code",
          attribute: "code",
          rules: requiredRule,
          type: "text",
          altText:
            "Used to quickly separate and identify your profile. This can be anything that is used internally within your company do identify this division, or as simple as the word 'Default'",
        },
        // Main Address
        { label: "Address", attribute: "address", type: "header" },
        { label: "Address Line One", attribute: "addressLineOne", type: "text", rules: requiredRule },
        { label: "Country", attribute: "country", type: "select", items: [], changeEvent: this.onCountryChange },
        { label: "State", attribute: "state", type: "select" },
        { label: "City", attribute: "city", type: "text" },
        { label: "Zip Code", attribute: "zipCode", type: "text" },
        { label: "Tax", attribute: "tax", type: "header" },
        {
          label: "Tax Identification Type",
          attribute: "taxIdentificationType",
          type: "select",
          changeEvent: this.onTaxTypeChange,
        },
        { label: "Tax Identification Number", attribute: "taxIdentificationNumber", type: "text" },
      ],
    };
  },
  methods: {
    async init() {
      this.states = await lookupServices.getAllStatesByCountry();
      this.taxes = await lookupServices.getAllTaxTypesByCountry();
      await this.getCountries();
    },
    async getCountries() {
      var countriesResult = await lookupServices.getCountries();

      let countries = countriesResult
        .filter(x => x.isActive)
        .map(x => {
          return { id: x.code, name: x.name };
        });
      this.ORGUNIT_FIELDS[COUNTRY_INDEX].items = countries;
    },
    onCountryChange() {
      if (this.profileData.country) {
        this.ORGUNIT_FIELDS[ZIPCODE_INDEX].label = this.zipCodeLabelName;
        this.ORGUNIT_FIELDS[STATE_INDEX].items = this.statesByCountry;
        this.ORGUNIT_FIELDS[TAX_ID_TYPE_INDEX].items = this.taxTypeByCountry;

        // this.ORGUNIT_FIELDS[TAX_NUMBER_INDEX].hint = this.taxFormat;
        this.setComputedMainAddressRules();
      }
    },
    onTaxTypeChange() {
      this.ORGUNIT_FIELDS[TAX_NUMBER_INDEX].hint = this.taxFormat;
    },
    setComputedMainAddressRules() {
      this.ORGUNIT_FIELDS[7].rules = this.mainAddressZipCodeRules;
    },
    zipCodeRules(country) {
      let rules = [];

      if (country === "US") rules.push(ValidationRules.zipCodeRule);

      if (country === "CA") rules.push(ValidationRules.postalCodeRule);
      return rules;
    },
  },
  computed: {
    mainAddressZipCodeRules() {
      const country = this.profileData?.country;
      let rules = this.zipCodeRules(country);
      return rules;
    },
    zipCodeLabelName() {
      if (!this.profileData?.country) return ZIP_CODE;

      return this.selectedCountry == "US" ? ZIP_CODE : POSTAL_CODE;
    },
    statesByCountry() {
      if (!this.profileData?.country) return [];
      return this.states[this.profileData.country].map(x => {
        return { id: x.code, name: x.name };
      });
    },
    taxTypeByCountry() {
      if (!this.profileData?.country) return [];
      return this.taxes[this.profileData.country].map(x => {
        return { id: x.Code, name: x.Name, format: x.Format };
      });
    },
    taxFormat() {
      if (!this.profileData?.country) return null;
      if (!this.profileData?.taxIdentificationType) return null;
      const taxFormats = this.taxTypeByCountry.find(x => x.id == this.profileData.taxIdentificationType).format;
      return taxFormats;
    },
  },
};
</script>
